module.exports = __webpack_public_path__ + "img/staytuned.a07aa818.png";